/**
 * Procedures explicitly allowed to use tRPC request batching by default.
 *
 * NOTE: Procedures routed to services/main via `@infinex/service-route-config`
 * must NOT be listed here — the web-app worker proxy matches the request
 * pathname exactly against a single procedure, so batched (comma-joined)
 * requests fall through to workers/main and 404.
 */
export const DEFAULT_BATCH_PATHS: readonly string[] = [
  'assets.getAssetMetadata',
];
